import React, { createContext, useState, useContext, useCallback } from "react";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("PT-br");

  const changeLanguage = useCallback((lang) => {
    setLanguage(lang);
  }, []);

  return (
    <ContentContext.Provider value={{ language, changeLanguage }}>
      {children}
    </ContentContext.Provider>
  );
};

const ContentContext = createContext();

export const useLanguage = () => {
  const context = useContext(ContentContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};

export default LanguageProvider;
